/**
 * Tell the desk that this page load opened a tagged letter link.
 * Only the recipient token and the tag are sent. Anything else in the
 * query stays on the page. A missing desk URL or a failed post is ignored.
 */
export function reportOutreachVisit(search: string): void {
  try {
    const base = import.meta.env.VITE_API_SERVER_URL;
    if (!base) return;

    const params = new URLSearchParams(search);
    const token = params.get("utm_recipient");
    const tag = params.get("tag");
    if (!token || !tag) return;

    const endpoint = `${base.replace(/\/+$/, "")}/outreach/visit`;
    void fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, tag }),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // The page still loads when the visit report cannot be sent.
  }
}
